var _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path10, _polygon2, _path11, _path12, _polygon3, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 717.67003,
    height: 453.96431,
    viewBox: "0 0 717.67003 453.96431",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.60118,309.43775a3.82674,3.82674,0,0,1-4.314,1.25745,5.82854,5.82854,0,0,1-.6787-.24764,28.82552,28.82552,0,0,0-.36725-7.98934,21.36236,21.36236,0,0,1-1.63966,6.57017,8.91079,8.91079,0,0,1-1.75993-2.51274,22.42528,22.42528,0,0,1-1.60307-6.0463c-1.20439-7.0881-2.39281-14.46206-.42756-21.389,2.87885-10.119,11.95723-17.39344,15.74893-27.21118l1.86811-1.677c3.19777,5.44543,3.33934,12.212,2.03576,18.38674-1.29657,6.187-3.90949,11.99371-5.97512,17.96023s-3.61313,12.31309-2.6548,18.55641C528.05421,306.56558,528.39023,308.18131,527.60118,309.43775Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230.469 157.098 218.295 212.779 271.469 230.098 263.65 157.098 230.469 157.098",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M861.31381,690.55887h24.09571V580.09012A107.65288,107.65288,0,0,0,777.87876,472.55887H553.94028A107.65288,107.65288,0,0,0,446.40952,580.09012V690.55887h24.0957V615.09012A108.65356,108.65356,0,0,1,579.036,506.55887H752.78305A108.65356,108.65356,0,0,1,861.31381,615.09012Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M568.509,632.7673l-25.68043-7.775a88.4837,88.4837,0,0,1-2.50888-20.963,8.39912,8.39912,0,0,1,13.815-6.35513c13.77338,11.81381,33.94829,18.11782,46.96791,31.58028a52.07341,52.07341,0,0,1,13.888,42.946l5.621,18.18083a87.2586,87.2586,0,0,1-63.97667-35.28461,84.28716,84.28716,0,0,1-10.12173-18.565C557.40487,635.29616,568.509,632.7673,568.509,632.7673Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M635.438,662.5404l13.09791-3.96554q.02533-.10428.0502-.2087a8.409,8.409,0,0,0-12.48265-9.09359c-5.94563,3.532-12.54779,6.57335-17.28929,11.47613a26.55922,26.55922,0,0,0-7.08337,21.904l-2.86689,9.27285a44.50485,44.50485,0,0,0,32.6303-17.99636,42.98864,42.98864,0,0,0,5.16243-9.46881C641.10146,663.83021,635.438,662.5404,635.438,662.5404Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M741.46337,391.0911H690.45778a2.72143,2.72143,0,0,0-2.71731,2.72433v80.57381h56.44722V393.81543A2.7229,2.7229,0,0,0,741.46337,391.0911Zm-25.3312,45.78106a6.05117,6.05117,0,0,1-6.02292-6.02289v-9.29349a6.02291,6.02291,0,0,1,12.04581,0v9.29349a6.05109,6.05109,0,0,1-6.02289,6.02289Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M825.92405,265.34656H607.895a7.07769,7.07769,0,0,0-7.06643,7.06638V419.53985a7.07318,7.07318,0,0,0,7.06643,7.06638h218.029a7.07318,7.07318,0,0,0,7.06643-7.06638V272.41294A7.07769,7.07769,0,0,0,825.92405,265.34656Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M824.10413,270.4505H609.71662a3.78733,3.78733,0,0,0-3.7791,3.787V417.71769a3.78562,3.78562,0,0,0,3.7791,3.7791H824.10413a3.78562,3.78562,0,0,0,3.7791-3.7791V274.23747A3.78733,3.78733,0,0,0,824.10413,270.4505Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M687.56538,471.812v7.77377a1.52285,1.52285,0,0,0,1.51976,1.51972h53.75792a1.52739,1.52739,0,0,0,1.51972-1.51972V471.812Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M782.34508,483.81055H654.7962a2.34634,2.34634,0,0,1-2.296-2.82966l1.97916-9.39973a2.35648,2.35648,0,0,1,2.29564-1.86291H780.36631a2.35648,2.35648,0,0,1,2.29565,1.86291l1.97915,9.39973a2.34634,2.34634,0,0,1-2.296,2.82966Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 402.06594,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 409.92271,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 417.77947,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 425.63623,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 433.493,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 441.34976,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 449.20652,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 457.06329,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 464.92005,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 472.77682,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 480.63358,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 488.49034,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 496.34711,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 504.20387,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 512.06064,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 519.9174,
    y: 233.44964,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 401.9731,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 409.82987,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 417.68663,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 425.54339,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 433.40016,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 441.25692,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 449.11369,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 456.97045,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 464.82721,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 472.68398,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 480.54074,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 488.39751,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 496.25427,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 504.11103,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 511.9678,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 519.82456,
    y: 237.37802,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 439.68557,
    y: 242.09208,
    width: 31.42706,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M792.13789,306.46885v75.52a19.07267,19.07267,0,0,1-19.07,19.07h-94.52a19.08094,19.08094,0,0,1-17.51-11.49,17.9844,17.9844,0,0,1-1.13-3.51,17.36726,17.36726,0,0,0,6.3,1.17h94.52a17.60458,17.60458,0,0,0,17.58-17.58v-75.52a17.36787,17.36787,0,0,0-1.17-6.3,17.98805,17.98805,0,0,1,3.51,1.13A19.08093,19.08093,0,0,1,792.13789,306.46885Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#f2f2f2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "183.897 368.973 174.522 374.778 146.903 340.828 160.739 332.262 183.897 368.973",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M447.60543,619.06017l-7.54133,3.36653-4.5245-6.519-.26914,8.65893-20.0014,8.92883a4.9238,4.9238,0,0,1-6.21365-7.05552l11.04809-18.1615-3.21326-7.198,17.248-6.49708Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M413.24955,600.40319l15.8338-15.34432c-11.7637-29.02906-12.70376-47.02215-29.01206-82.13088,38.693,7.91409,66.35622,7.433,98.35619.33742,10.83323-2.3646,38.78551-23.95594,36.48735-35.02685q-.16112-.77624-.3807-1.538c-3.43482-11.7114-1.01609-29.64574-8.45078-42.64173-13.75489-5.18582-34.65268,12.32556-51,23-7.88255,5.14713-2.11233,12.1612-8,14l-22.569,7.32613-55.3725-8.943a20.51148,20.51148,0,0,0-23.37624,17.35929q-.14055.9018-.20361,1.81341c2.54779,14.10343,5.20366,27.83673,8.063,40.87333.923,4.20807-.6352,12.27539,2.8357,12.39545s2.07272,8.46395,3.15368,12.54322C386.2692,569.54028,390.47748,581.69383,413.24955,600.40319Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "127.329 429.745 117.562 424.647 133.015 383.711 147.43 391.235 127.329 429.745",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M381.31592,637.14483l15.6612,10.78289c19.19456-27.75961,31.65753-64.854,40.93905-106.36,36.13851-15.76472,67.76063-33.80089,89.79648-57.99314a20.9147,20.9147,0,0,0-1.20931-29.095q-.5784-.5422-1.196-1.03885c-9.54471-7.60285-30.74283-3.22816-44.29181-9.58275l-24.204,33.49961,2.78211,7.80252-8.41994,4.099-7.1092,3.46086-8.13813,3.96175L409.24825,509.669a20.4837,20.4837,0,0,0-9.089,27.62925q.40434.81821.87758,1.59992l-9.908,49.36015s2.72631,8.59307-1.56348,7.789-1.95215,9.72532-1.95215,9.72532Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M377.029,690.26656l-7.32146-3.82115,2.30077-7.5944-6.95466,5.16548-19.41828-10.13462a4.9238,4.9238,0,0,1,1.67253-9.25162l21.09632-2.61639,3.64718-6.98813,15.80243,9.48616Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M590.50644,475.66465l-11.42309-27.60578-9,5,5.43524,28.0821a10.0012,10.0012,0,1,0,14.98785-5.47632Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398.82273,257.36811l17.381,24.29955,7.633-6.90918L412.18,248.63825a10.0012,10.0012,0,1,0-13.35723,8.72986Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M477.31168,411.38205c-11.2735,17.48627,30.02795,55.58585,51.77167,46.67682,3.80743-1.56,16.90438-6.71266,7.95219-13.85633s1.03792.851,1.274-3.79932c.15787-3.109-2.24924-9.9292.26227-9.63677s3.953-6.97133-1.51673-8.82157a10.61794,10.61794,0,0,1-7-9c-.523-19.16651,5.96782-39.17735,5.96782-39.17735l26.49793,67.73493s-.19573,11.71851,3.18337,8.13746,3.13322,8.00923,3.13322,8.00923,5.02458,3.50661,2.13523,5.45816,3.11066,7.95156,3.11066,7.95156l14-1s-.21919-10.4-2.6096-12.7-1.21623-5.919-1.21623-5.919-4.92825-4.58417-2.05121-9.98259-20.951-101.96148-20.951-101.96148a25.7199,25.7199,0,0,0-18.366-19.62039l-15.12093-4.16334-2.685-10.6532H503.792l-3.70866,7-34-3s-33.64257-30.60991-32-33-3.57255-7.98576-3.57255-7.98576-4.45387-1.45771-1.94066-2.236-2.23723-2.57768-2.23723-2.57768-4.39964-1.1561-2.3246-2.67834-6.925-2.52224-6.925-2.52224l-11.67717,9.52756,2.3601,4.00191s-1.439,5.44938.439,3.46,2.23156,3.78393,2.23156,3.78393.95909,6.32194,6.64648,8.22664,10,20,10,20l48,40c-7.31055,8.39115-5.5705,17.166.90564,26.14173Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258.34259,
    cy: 36.96382,
    r: 23.0557,
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M534.08335,268.05887c-.59.17-9.25,1.3-13,2-3.68.69-4.32-4-7.33-3.12a.1266.1266,0,0,0-.01-.06,28.34378,28.34378,0,0,0-2.37-7.17,21.17806,21.17806,0,0,1,.17005,6.6.98419.98419,0,0,1-.02.17c-.01.1-.03.19-.04.29-3.18-1.4-5.2-.15-7.4.29-2.46.49-4.38,1.57-3,10,2.83,17.34,17.55,23.53,15,35-.5,2.27-1.76,5.11-3.34,5.82a28.34378,28.34378,0,0,0-2.37-7.17,21.17806,21.17806,0,0,1,.17005,6.6c-2.45-2.65-4.22-11.91-12.46-19.25-2.03-1.8-12.2-12.48-13.42-15a32.13615,32.13615,0,0,1,.54,6.11,29.41586,29.41586,0,0,1-.28,4.1,1.15145,1.15145,0,0,1-.03.26c-.01.16-.04.3-.06.45-.02.17-.05.33-.08.5-3.33-.48-6.28-1.06-7.67-2.42-6.76-6.58,1.49-19.4,6-31,6.45-16.61,25.18-18.82,27-19,8.02-.81,21.57.91,26,10C539.18332,258.42887,537.20334,267.15885,534.08335,268.05887Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M485.46837,271.80814l16.70111-25.98028a25.61246,25.61246,0,0,0-13.18811-3.4596,16.41918,16.41918,0,0,0-12.10913,5.71143c-3.41095,4.2392-3.99622,10.23181-2.7182,15.52069C474.59538,265.427,483,259,481,262c-1.64185,2.34882-4.3266,12.2215-5,15-1.08368,4.4718-4.06343,9.06211-1.40907,12.82053,3.13885,4.44446,8.74,6.65363,14.17651,6.878s10.7876-1.28223,15.95416-2.98871Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M491.88559,270.78348a1.00011,1.00011,0,0,1-.27295-1.96191c.26221-.43262.15479-2.25342.06836-3.72461-.32519-5.52393-.86963-14.769,8.106-21.00977a.99976.99976,0,0,1,1.1416,1.6416c-8.05469,5.60108-7.57129,13.81543-7.251,19.25049.18262,3.10742.315,5.352-1.56982,5.7793A.99351.99351,0,0,1,491.88559,270.78348Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M255.61478,689.91176a1.18648,1.18648,0,0,0,1.18292,1.19H972.09481a1.19,1.19,0,0,0,0-2.38h-715.29a1.18649,1.18649,0,0,0-1.19,1.183Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M698.14954,332.81065H683.01746a1.51321,1.51321,0,0,1,0-3.02642h15.13208a1.51321,1.51321,0,0,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M725.38727,332.81065H710.2552a1.51321,1.51321,0,1,1,0-3.02642h15.13207a1.51321,1.51321,0,1,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M739.00614,344.91631H723.87407a1.51321,1.51321,0,1,1,0-3.02642h15.13207a1.51321,1.51321,0,1,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M711.8519,344.91631H683.01746a1.51321,1.51321,0,0,1,0-3.02642H711.8519a1.51321,1.51321,0,0,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M766.32737,332.81065H737.49293a1.51321,1.51321,0,0,1,0-3.02642h28.83444a1.51321,1.51321,0,1,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M708.50929,309.88668H679.67486a1.51321,1.51321,0,1,1,0-3.02641h28.83443a1.5132,1.5132,0,1,1,0,3.02641Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M710.88008,318.72742a1.35512,1.35512,0,0,1-.83239-2.425l7.38326-5.73907a2.71359,2.71359,0,0,0,.328-3.9837l-6.19864-6.7106a1.35508,1.35508,0,1,1,1.99032-1.83946l9.20523,9.96483a1.3553,1.3553,0,0,1-.16344,1.98966l-10.88125,8.45819A1.35141,1.35141,0,0,1,710.88008,318.72742Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M678.21581,318.72742a1.35512,1.35512,0,0,0,.83239-2.425l-7.38326-5.73907a2.71358,2.71358,0,0,1-.328-3.9837l6.19864-6.7106a1.35508,1.35508,0,0,0-1.99032-1.83946l-9.20523,9.96483a1.35531,1.35531,0,0,0,.16343,1.98966l10.88126,8.45819A1.35136,1.35136,0,0,0,678.21581,318.72742Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M723.41551,370.86669H694.58108a1.51321,1.51321,0,0,1,0-3.02642h28.83443a1.51321,1.51321,0,0,1,0,3.02642Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M728.49652,378.35231a1.35512,1.35512,0,0,1-.83239-2.425l7.38326-5.73907a2.71357,2.71357,0,0,0,.328-3.98369l-6.19864-6.71061a1.35508,1.35508,0,0,1,1.99032-1.83946l9.20523,9.96483a1.35531,1.35531,0,0,1-.16343,1.98966l-10.88125,8.4582A1.35146,1.35146,0,0,1,728.49652,378.35231Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M678.21581,378.35231a1.35512,1.35512,0,0,0,.83239-2.425l-7.38326-5.73907a2.71357,2.71357,0,0,1-.328-3.98369l6.19864-6.71061a1.35508,1.35508,0,1,0-1.99032-1.83946l-9.20523,9.96483a1.35531,1.35531,0,0,0,.16343,1.98966l10.88126,8.4582A1.35142,1.35142,0,0,0,678.21581,378.35231Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M680.78914,374.11256l6.06111-13.86516a1.51321,1.51321,0,0,1,2.773,1.21223l-6.06112,13.86515a1.51321,1.51321,0,1,1-2.773-1.21222Z",
    transform: "translate(-255.61478 -237.96119)",
    fill: "#bc63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.2d9afca7c0d352927b2827fe9ecc888d.svg";
export { ForwardRef as ReactComponent };